import React, { useState, useEffect, useCallback } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import AccountsMenu from "./AccountsMenu";
import { NavLink, Link } from "react-router-dom";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ReceiptPayment() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [DefaultFYear] = useState(
    () => localStorage.getItem("DefaultFYear") || ""
  );

  const [loading, setLoading] = useState(false);
  const [listOpening, setListOpening] = useState([]);
  const [listReceipts, setListReceipts] = useState([]);
  const [listPayments, setListPayments] = useState([]);
  const [listClosing, setListClosing] = useState([]);

  const [openingDebitTotal, setOpeningDebitTotal] = useState("");
  const [openingCreditTotal, setOpeningCreditTotal] = useState("");
  const [receiptsDebitTotal, setReceiptsDebitTotal] = useState("");
  const [receiptsCreditTotal, setReceiptsCreditTotal] = useState("");
  const [paymentsDebitTotal, setPaymentsDebitTotal] = useState("");
  const [paymentsCreditTotal, setPaymentsCreditTotal] = useState("");
  const [closingDebitTotal, setClosingDebitTotal] = useState("");
  const [closingCreditTotal, setClosingCreditTotal] = useState("");

  const [AccountLevel, setAccountLevel] = useState("0");
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState(() =>
    moment().format(config.date_format_input)
  );
  const [zeroAccounts, setZeroAccounts] = useState(true);
  const [showThirdOnly, setShowThirdOnly] = useState(true);
  const [Account_Code, setAccount_Code] = useState("");
  const [Account_Description, setAccount_Description] = useState("");
  const [appliedCode, setAppliedCode] = useState("");
  const [appliedName, setAppliedName] = useState("");

  const fyStartDate = DefaultFYear
    ? `${DefaultFYear}-04-01`
    : moment().format(config.date_format_input);

  const fetchReceiptPayment = useCallback(() => {
    const year = parseInt(DefaultFYear, 10);
    if (!year) {
      setListOpening([]);
      setListReceipts([]);
      setListPayments([]);
      setListClosing([]);
      toast.error("Financial year is not set. Use Accounts → Change Year.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    if (!EndDate) {
      return;
    }

    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "Accounts/GetReceiptPayment",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        pageNo: 1,
        pageSize: 10000,
        FYear: year,
        StartDate: StartDate || fyStartDate,
        EndDate,
        AccountLevel: parseInt(AccountLevel, 10) || 0,
        ShowZeroAccounts: zeroAccounts,
        ShowThirdOnly: showThirdOnly,
        AccountCode: appliedCode,
        AccountName: appliedName,
      },
    })
      .then((response) => {
        if (response.data?.status_code === 1) {
          setListOpening(
            Array.isArray(response.data?.ListofOpening)
              ? response.data.ListofOpening
              : []
          );
          setListReceipts(
            Array.isArray(response.data?.ListofReceipts)
              ? response.data.ListofReceipts
              : []
          );
          setListPayments(
            Array.isArray(response.data?.ListofPayments)
              ? response.data.ListofPayments
              : []
          );
          setListClosing(
            Array.isArray(response.data?.ListofClosing)
              ? response.data.ListofClosing
              : []
          );
          setOpeningDebitTotal(response.data?.OpeningDebitTotal ?? "");
          setOpeningCreditTotal(response.data?.OpeningCreditTotal ?? "");
          setReceiptsDebitTotal(response.data?.ReceiptsDebitTotal ?? "");
          setReceiptsCreditTotal(response.data?.ReceiptsCreditTotal ?? "");
          setPaymentsDebitTotal(response.data?.PaymentsDebitTotal ?? "");
          setPaymentsCreditTotal(response.data?.PaymentsCreditTotal ?? "");
          setClosingDebitTotal(response.data?.ClosingDebitTotal ?? "");
          setClosingCreditTotal(response.data?.ClosingCreditTotal ?? "");
        } else {
          setListOpening([]);
          setListReceipts([]);
          setListPayments([]);
          setListClosing([]);
          if (response.data?.status_message) {
            toast.info(response.data.status_message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        }
      })
      .catch(() => {
        setListOpening([]);
        setListReceipts([]);
        setListPayments([]);
        setListClosing([]);
        toast.error("Network Error..", {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .finally(() => setLoading(false));
  }, [
    AccessKey,
    UserID,
    MemberType,
    DefaultFYear,
    StartDate,
    EndDate,
    AccountLevel,
    zeroAccounts,
    showThirdOnly,
    appliedCode,
    appliedName,
    fyStartDate,
  ]);

  useEffect(() => {
    document.title = "Receipt Payment Account";
    if (!StartDate && DefaultFYear) {
      setStartDate(`${DefaultFYear}-04-01`);
    }
  }, [DefaultFYear, StartDate]);

  useEffect(() => {
    if (EndDate && DefaultFYear) {
      fetchReceiptPayment();
    }
  }, [fetchReceiptPayment, EndDate, DefaultFYear]);

  const handleSearch = () => {
    setAppliedCode((Account_Code || "").trim());
    setAppliedName((Account_Description || "").trim());
  };

  const printParams = new URLSearchParams({
    fyear: DefaultFYear || "",
    startDate: StartDate || fyStartDate || "",
    endDate: EndDate || "",
    accountLevel: AccountLevel || "0",
    showZeroAccounts: zeroAccounts ? "1" : "0",
    showThirdOnly: showThirdOnly ? "1" : "0",
    accountCode: Account_Code || "",
    accountName: Account_Description || "",
  });

  const renderSection = (rows, debitTotal, creditTotal, emptyColSpan = 5) => {
    if (loading) {
      return (
        <tr>
          <td className="text-center" colSpan={emptyColSpan}>
            <Spinner animation="border" role="status" />
          </td>
        </tr>
      );
    }

    if (rows != null && rows.length > 0) {
      return (
        <>
          {rows.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item.Selected_Account?.Account_Code}</td>
              <td>{item.Selected_Account?.Account_Description}</td>
              <td className="text-end">{item.ClosingDebit}</td>
              <td className="text-end">{item.ClosingCredit}</td>
            </tr>
          ))}
          <tr>
            <td colSpan={3} className="text-end fw-semibold">
              Total
            </td>
            <td className="text-end fw-semibold">{debitTotal}</td>
            <td className="text-end fw-semibold">{creditTotal}</td>
          </tr>
        </>
      );
    }

    return (
      <tr>
        <td colSpan={emptyColSpan}>
          <h4
            className="mt-3 mb-0"
            style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
          >
            No Data Found
          </h4>
        </td>
      </tr>
    );
  };

  const sectionTable = (title, rows, debitTotal, creditTotal) => (
    <div className="card mt-3">
      <div className="card-body responsive-table">
        <table className="table table-theme table-hover mb-0">
          <tbody>
            <tr>
              <th colSpan={5}>{title}</th>
            </tr>
            <tr>
              <th style={{ width: "60px" }}>Sr.</th>
              <th>Account Code</th>
              <th>Account Name</th>
              <th className="text-end">Debit</th>
              <th className="text-end">Credit</th>
            </tr>
            {renderSection(rows, debitTotal, creditTotal)}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <>
      <AccountsMenu />
      <ToastContainer />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/Accounts/AccountsDashboard">Accounts</NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Receipt Payment Account
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Receipt Payment Account</div>
                <p className="text-muted small mb-0">
                  Opening &amp; closing: cash/bank (10). Receipts: income (60).
                  Payments: expenditure (70). Year: {DefaultFYear || "—"}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container">
            <div className="card">
              <div className="card-body">
                <div className="row align-items-center gy-3">
                  <div className="col-md-2">
                    <label>Select Level</label>
                    <select
                      className="form-select"
                      value={AccountLevel}
                      onChange={(e) => setAccountLevel(e.target.value)}
                    >
                      <option value="0">All Levels</option>
                      <option value="1">1st Level</option>
                      <option value="2">2nd Level</option>
                      <option value="3">3rd Level</option>
                    </select>
                  </div>
                  <div className="col-md-2">
                    <label>Start Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={StartDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      max={moment().format(config.date_format_input)}
                    />
                  </div>
                  <div className="col-md-2">
                    <label>End Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={EndDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      max={moment().format(config.date_format_input)}
                    />
                  </div>
                  <div className="col-md-2">
                    <label>Account Code</label>
                    <input
                      type="text"
                      className="form-control"
                      value={Account_Code}
                      onChange={(e) => setAccount_Code(e.target.value)}
                      placeholder="Starts with…"
                    />
                  </div>
                  <div className="col-md-2">
                    <label>Account Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={Account_Description}
                      onChange={(e) => setAccount_Description(e.target.value)}
                      placeholder="Contains…"
                    />
                  </div>
                  <div className="col-md-2">
                    <div className="form-check mt-md-4">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={zeroAccounts}
                        onChange={(e) => setZeroAccounts(e.target.checked)}
                        id="rpShowZero"
                      />
                      <label className="form-check-label" htmlFor="rpShowZero">
                        Show Zero Accounts
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={showThirdOnly}
                        onChange={(e) => setShowThirdOnly(e.target.checked)}
                        id="rpThirdOnly"
                      />
                      <label className="form-check-label" htmlFor="rpThirdOnly">
                        3rd Level Only
                      </label>
                    </div>
                  </div>
                  <div className="col-md-12 text-md-end">
                    <input
                      type="button"
                      value="Search"
                      className="button button-primary"
                      onClick={handleSearch}
                    />
                    <Link
                      to={`/Accounts/PrintReceiptPayment?${printParams.toString()}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="button button-primary ms-2"
                    >
                      Print
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {sectionTable(
              "Opening Balance (Cash & Bank)",
              listOpening,
              openingDebitTotal,
              openingCreditTotal
            )}
            {sectionTable(
              "Receipts (Income)",
              listReceipts,
              receiptsDebitTotal,
              receiptsCreditTotal
            )}
            {sectionTable(
              "Payments (Expenditure)",
              listPayments,
              paymentsDebitTotal,
              paymentsCreditTotal
            )}
            {sectionTable(
              "Closing Balance (Cash & Bank)",
              listClosing,
              closingDebitTotal,
              closingCreditTotal
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ReceiptPayment;

